var map = {
	"./bookmark.svg": "./src/assets/icons/bookmark.svg",
	"./browser.svg": "./src/assets/icons/browser.svg",
	"./bug.svg": "./src/assets/icons/bug.svg",
	"./checkmark.svg": "./src/assets/icons/checkmark.svg",
	"./cheveron-down.svg": "./src/assets/icons/cheveron-down.svg",
	"./cheveron-up.svg": "./src/assets/icons/cheveron-up.svg",
	"./close.svg": "./src/assets/icons/close.svg",
	"./cog.svg": "./src/assets/icons/cog.svg",
	"./copy.svg": "./src/assets/icons/copy.svg",
	"./download.svg": "./src/assets/icons/download.svg",
	"./error.svg": "./src/assets/icons/error.svg",
	"./github.svg": "./src/assets/icons/github.svg",
	"./hot.svg": "./src/assets/icons/hot.svg",
	"./hour-glass.svg": "./src/assets/icons/hour-glass.svg",
	"./imdb.svg": "./src/assets/icons/imdb.svg",
	"./info.svg": "./src/assets/icons/info.svg",
	"./jsonld.svg": "./src/assets/icons/jsonld.svg",
	"./logout.svg": "./src/assets/icons/logout.svg",
	"./media-kraken-confused.svg": "./src/assets/icons/media-kraken-confused.svg",
	"./media-kraken.svg": "./src/assets/icons/media-kraken.svg",
	"./menu.svg": "./src/assets/icons/menu.svg",
	"./more.svg": "./src/assets/icons/more.svg",
	"./netflix.svg": "./src/assets/icons/netflix.svg",
	"./photo.svg": "./src/assets/icons/photo.svg",
	"./question.svg": "./src/assets/icons/question.svg",
	"./reload.svg": "./src/assets/icons/reload.svg",
	"./search-empty.svg": "./src/assets/icons/search-empty.svg",
	"./search.svg": "./src/assets/icons/search.svg",
	"./solid-emblem.svg": "./src/assets/icons/solid-emblem.svg",
	"./terminal.svg": "./src/assets/icons/terminal.svg",
	"./time.svg": "./src/assets/icons/time.svg",
	"./tmdb.svg": "./src/assets/icons/tmdb.svg",
	"./trash.svg": "./src/assets/icons/trash.svg",
	"./tviso.svg": "./src/assets/icons/tviso.svg",
	"./upload.svg": "./src/assets/icons/upload.svg",
	"./view-list.svg": "./src/assets/icons/view-list.svg",
	"./wrench.svg": "./src/assets/icons/wrench.svg"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/assets/icons sync recursive ^\\.\\/.*\\.svg$";